import {getConfig, once} from './core.js';

function recipientData(trigger) {
	const rawRecipient = String(trigger.dataset.email || '');
	const legacy = trigger.dataset.karta ? null : rawRecipient.match(/^(.+)_([0-9]+)$/);
	const recipient = legacy?.[1] || rawRecipient;
	const localPart = recipient.replace(/@vtc\.cz$/i, '');
	return {
		address: recipient.includes('@') ? recipient : `${localPart}@vtc.cz`,
		card: trigger.dataset.karta || legacy?.[2] || '',
		localPart,
	};
}

function openDialog(trigger) {
	const dialog = document.getElementById('dlgKontakt');
	const jquery = window.jQuery;
	if (!dialog || !jquery) {
		return;
	}
	const recipient = recipientData(trigger);
	if (!recipient.localPart) {
		return;
	}
	const config = getConfig();
	dialog.querySelector('.modal-title').textContent = `${config.contactDialog?.title || ''} - ${recipient.address}`;
	dialog.querySelector('input[name="emailTo"]').value = recipient.localPart;
	dialog.querySelector('input[name="karta"]').value = recipient.card;

	jquery(dialog)
		.one('shown.bs.modal', () => dialog.querySelector('textarea[name="zprava"]')?.focus())
		.one('hidden.bs.modal', () => trigger.focus())
		.modal('show');
}

function bindTrigger(trigger) {
	if (!once(trigger, 'contact-dialog')) {
		return;
	}
	if (!trigger.matches('a, button')) {
		trigger.setAttribute('role', 'button');
		trigger.tabIndex = 0;
		trigger.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				openDialog(trigger);
			}
		});
	}
	trigger.addEventListener('click', (event) => {
		event.preventDefault();
		openDialog(trigger);
	});
}

export function init(root = document) {
	root.querySelectorAll('.email[data-email]').forEach(bindTrigger);
}
